import { JobChange } from "@webmonitoring/vp-common";
import ProgressBar from "@/components/UI/ProgressBar/ProgressBar";
import classNames from "classnames";

interface DifferenceProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  historyItem: any;
  section?: any;
}

const DifferenceProgressBar = ({ className, historyItem, section, ...props }: DifferenceProgressBarProps) => {
  return (
    <div className={classNames("flex items-center gap-1", className)} {...props}>
      {section?.DifferenceProgressBarLabel && (
        <div className="shrink-0 text-sm font-bold uppercase tracking-tight">{section?.DifferenceProgressBarLabel}</div>
      )}
      <div className="text-sm">
        {historyItem.PercentDifference
          ? historyItem.PercentDifference < 1
            ? historyItem.PercentDifference.toFixed(1) + "%"
            : Math.min(Math.round(historyItem.PercentDifference ?? 0), 100) + "%"
          : null}
      </div>
      <ProgressBar percent={historyItem.PercentDifference} title="Percent Diffrence" />
    </div>
  );
};

export default DifferenceProgressBar;
